import React from 'react';
import { useOnboarding } from '../../context/OnboardingContext';

// Barra fija arriba mientras corre el tour: cuánto falta de un vistazo.
export default function TourProgressBar() {
  const { tourActive, currentStepIndex, steps } = useOnboarding();
  if (!tourActive || !steps?.length) return null;
  const pct = Math.round(((currentStepIndex + 1) / steps.length) * 100);
  return (
    <div
      className="soem-tour-progress-bar"
      data-testid="tour-progress"
      role="progressbar"
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={pct}
      aria-label={`Paso ${currentStepIndex + 1} de ${steps.length}`}
      style={{ width: `${pct}%` }}
    />
  );
}
